import { render } from "./IconReceipt.vue.js?vue&type=template&id=20cf0344!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconReceipt.vue?vue&type=template&id=20cf0344"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__